import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { SectionDef, FormValues } from '../types';
import FormField from './FormField';

interface FormSectionProps {
  section: SectionDef;
  index: number;
  values: FormValues;
  onChange: (key: string, value: string | string[]) => void;
  accentColor: string;
  fieldErrors?: Record<string, string>;
}

export default function FormSection({ section, index, values, onChange, accentColor, fieldErrors }: FormSectionProps) {
  return (
    <Accordion defaultExpanded={index === 0} disableGutters elevation={0} sx={{ border: '1px solid', borderColor: 'divider', '&:before': { display: 'none' }, borderRadius: 1, overflow: 'hidden', mb: 1 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          bgcolor: 'grey.50',
          borderBottom: '1px solid',
          borderColor: 'divider',
          minHeight: 48,
          '&.Mui-expanded': { minHeight: 48 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              bgcolor: accentColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Typography variant="caption" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1 }}>
              {index + 1}
            </Typography>
          </Box>
          <Typography variant="subtitle2" fontWeight={600}>
            {section.title}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
            ({section.fields.length} campo{section.fields.length !== 1 ? 's' : ''})
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2.5, pb: 2, px: 2.5 }}>
        <Grid container spacing={2}>
          {section.fields.map((field) => (
            <Grid key={field.key} size={field.type === 'textarea' ? 12 : { xs: 12, sm: 6 }}>
              <FormField field={field} values={values} onChange={onChange} externalError={fieldErrors?.[field.key]} />
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
